import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="grid min-h-screen place-items-center bg-navy text-sand-50" data-testid="admin-loading">
        <span className="font-grotesk text-sm uppercase tracking-[0.3em] text-gold">Memuat…</span>
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
